/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { useState } from "react"
import { SectionGrid } from "frontend/src/components/Layout"
import { BlockText } from "frontend/src/components/BlockText"
import { navigate } from "gatsby"

function ContactForm({ title, introText }) {
  // styles
  const labelStyles = {
    display: "block",
    fontSize: [0, 1],
    lineHeight: "20px",
    fontWeight: "medium",
    color: "almostBlack",
    mb: 3,
  }
  const inputStyles = {
    display: "block",
    border: "none",
    backgroundColor: "#f6f6f6",
    width: "100%",
    height: "50px",
    mb: 6,
    padding: 5,
    fontSize: 0,
    fontFamily: "body",
    lineHeight: 1.42857143,
    color: "#333333",
    verticalAlign: "middle",
    "&:active": {
      border: "none",
      outline: "none",
    },
    "&:focus": {
      border: "none",
      outline: "none",
    },
  }
  const textareaStyles = {
    display: "block",
    border: "none",
    backgroundColor: "#f6f6f6",
    width: "100%",
    height: "250px",
    mb: 8,
    padding: 5,
    fontFamily: "body",
    fontSize: 0,
    lineHeight: 1.42857143,
    color: "#333333",
    verticalAlign: "middle",
    "&:active": {
      border: "none",
      outline: "none",
    },
    "&:focus": {
      border: "none",
      outline: "none",
    },
  }
  // state
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const checkParameters = () => {
    if (name && name.length > 0 && email && email.length > 0 && message && message.length > 0) {
      return true
    }
    return false
  }
  const sendMail = e => {
    e.preventDefault()
    const correctParameters = checkParameters()
    if (correctParameters) {
      fetch("/.netlify/functions/email", {
        method: "POST",
        body: JSON.stringify({ name, email, message }),
      })
        .then(response => response.status)
        .then(status => {
          console.log(status)
          if (status === 200) {
            navigate("/feedback-thankyou")
          } else {
            navigate("/feedback-fail")
          }
        })
        .catch(() => navigate("/feedback-fail"))
    }
  }
  return (
    <SectionGrid sx={{ pt: [10, 13], pb: [7, 8], px: [5, 0] }}>
      <SectionGrid.narrow>
        <h2
          sx={{
            fontFamily: "heading",
            fontSize: ["30px", "38px"],
            lineHeight: ["32px", "44px"],
            fontWeight: "regular",
            mb: 5,
            letterSpacing: "-1.24px",
            color: "almostBlack",
          }}
        >
          {title}
        </h2>
        <div sx={{ mb: 11 }}>
          <BlockText
            blocks={introText}
            style={{
              color: "almostBlack",
              fontFamily: "body",
              fontSize: "20px",
              lineHeight: "26px",
              fontWeight: "light",
              mb: 5,
              mt: 0,
            }}
          />
        </div>
        <form onSubmit={sendMail}>
          <label htmlFor="name" sx={{ ...labelStyles }}>
            Name *
          </label>
          <input
            type="text"
            name="name"
            value={name}
            onChange={e => setName(e.target.value)}
            required
            sx={{
              ...inputStyles,
            }}
          />
          <label htmlFor="email" sx={{ ...labelStyles }}>
            E-Mail *
          </label>
          <input
            type="email"
            name="email"
            required
            sx={{ ...inputStyles }}
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <label htmlFor="message" sx={{ ...labelStyles }}>
            Ihre Nachricht *
          </label>
          <textarea
            name="message"
            sx={{ ...textareaStyles }}
            required
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
          <button
            type="submit"
            sx={{
              fontFamily: "heading",
              backgroundColor: "#111111",
              textAlign: "center",
              px: 7,
              py: 5,
              opacity: 1,
              color: "background",
              textTransform: "uppercase",
              fontSize: "16px",
              lineHeight: 1.0,
              fontWeight: "light",
              border: "none",
              cursor: "pointer",
              transition: "all 0.1s linear",
              ":focus": { outline: "none", opacity: "0.9" },
              ":active": { opacity: "0.8" },
              ":hover": { opacity: 0.6 },
            }}
          >
            Absenden
          </button>
        </form>
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { ContactForm }
